import * as React from "react";

const SvgConditionalIcon = props => <svg width="100%" height="100%" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><rect width="100%" height="100%" fill="#29292D" /><path d="M19.7926 17.788V32.3335H17.598V17.788H19.7926ZM22.9886 32.3335V17.788H32.0085V19.6772H25.1832V24.1091H31.3622V25.9912H25.1832V32.3335H22.9886Z" fill="white" /></svg>;

export default SvgConditionalIcon;